import webIconBlack from "../../assets/web.png";
import webIconWhite from "../../assets/web-2.png";

export const WebAPIIcon = ({ isBlack, style }) => {
    return (
        <div style={style}>
            <img
                src={isBlack ? webIconBlack : webIconWhite}
                alt="Web API Icon"
                style={{
                    width: "100%",
                    height: "100%",
                }}
            />
        </div>
    );
    }